var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"btn-create-channel is-outlined",attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('plus-icon',{attrs:{"size":"1.5x"}}),_vm._v(" "+_vm._s(_vm.$t('dict.newItem'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }